<template>
  <div class="fullheight">
    <el-drawer
      class="sideDrawer"
      :size="drawerSize"
      title="表单扩展设置"
      :visible.sync="dialogVisible"
      z-index="1000"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      destory-on-close
    >
      <i
        class="iconfont icon-back-quanping iconFull"
        @click="drawerSize = '100%'"
        v-if="drawerSize == '90%'"
      />
      <i
        @click="drawerSize = '90%'"
        class="iconfont icon-back-tuichuquanping iconFull"
        v-else
      />
      <div style="padding: 20px;height: calc(100% - 40px)">
        <el-row style="margin-top: 5px;margin-bottom: 10px">
          <el-col :span="8">表单名称：<vxe-input
              v-model="formName"
              disabled
              style="width: 150px;"
            ></vxe-input></el-col>
          <el-col :span="8">是否启用：<vxe-switch
              v-model="formStatus"
              open-value="enable"
              close-value="disable"
            ></vxe-switch></el-col>
        </el-row>
        <vxe-toolbar>
          <template #buttons>
            <el-button
              type="primary"
              size="small"
              @click="insertEvent(-1)"
            >添加</el-button>
          </template>
        </vxe-toolbar>
        <vxe-table
          border
          resizable
          show-overflow
          keep-source
          ref="xTable"
          max-height="600"
          :data="schema"
          :edit-rules="formRules"
          :sort-config="{ trigger: 'cell' }"
          :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
        >
          <vxe-column
            type="seq"
            width="60"
            title="序号"
          ></vxe-column>
          <vxe-column
            field="label"
            title="字段名称"
          >
            <template #default="{ row }">
              <vxe-input
                v-model="row.label"
                type="text"
              ></vxe-input>
            </template>
          </vxe-column>
          <vxe-column
            field="order"
            title="字段排序"
            width="160"
          >
            <template #default="{ row }">
              <vxe-input
                v-model="row.order"
                type="integer"
              ></vxe-input>
            </template>
          </vxe-column>
          <vxe-column
            field="type"
            title="字段类型"
          >
            <template #default="{ row }">
              <vxe-select
                v-model="row.type"
                transfer
              >
                <vxe-option
                  v-for="item in expandFieldTypes"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                ></vxe-option>
              </vxe-select>
            </template>
          </vxe-column>
          <!-- 是否必填 -->
          <vxe-column
            field="required"
            title="验证规则"
            show-overflow
          >
            <template #default="{ row }">
              <vxe-select
                v-model="row.config.validators"
                transfer
                multiple
              >
                <vxe-option
                  v-for="item in validators"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                ></vxe-option>
              </vxe-select>
            </template>
          </vxe-column>
          <!-- 是否启用 -->
          <vxe-column
            field="enabled"
            title="是否启用"
            show-overflow
          >
            <template #default="{ row }">
              <vxe-select
                v-model="row.enabled"
                transfer
              >
                <vxe-option
                  v-for="item in status"
                  :key="item.code"
                  :value="item.code"
                  :label="item.name"
                ></vxe-option>
              </vxe-select>
            </template>
          </vxe-column>
          <vxe-column
            field="config"
            width="0"
          >
          </vxe-column>
          <vxe-column
            title="操作"
            width="160"
            show-overflow
          >
            <template #default="{ row }">
              <vxe-button @click="editEvent(row)">编辑</vxe-button>
              <vxe-button @click="removeEvent(row)">删除</vxe-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <div class="demo-drawer__footer">
        <el-button
          @click="dialogVisible=false"
          size="small"
        >取消</el-button>
        <el-button
          @click="saveEvent"
          type="primary"
          size="small"
        >提交</el-button>
      </div>

      <!--新增编辑表单-->
      <vxe-modal
        v-model="showEdit"
        :title="selectRow ? '编辑&保存' : '新增&保存'"
        width="600"
        min-width="400"
        min-height="300"
        resize
        destroy-on-close
      >
        <template #default>
          <vxe-form
            ref="configForm"
            :data="formData"
            :rules="formRules"
            title-align="right"
            title-width="100"
            @submit="submitEvent"
          >
            <vxe-form-item
              field="label"
              title="字段名称"
              :span="24"
              :item-render="{}"
            >
              <template #default="{ data }">
                <vxe-input
                  v-model="data.label"
                  placeholder="请输入名称"
                ></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item
              field="order"
              title="字段排序"
              :span="24"
              :item-render="{}"
            >
              <template #default="{ data }">
                <vxe-input
                  v-model="data.order"
                  :min="0"
                  type="integer"
                  placeholder="请输入排序"
                ></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item
              field="type"
              title="字段类型"
              :span="24"
              :item-render="{}"
            >
              <template #default="{ data }">
                <vxe-select
                  ref="fieldType"
                  v-model="data.type"
                  placeholder="请选择"
                  transfer
                  @change="typeChange(data)"
                >
                  <vxe-option
                    v-for="item in expandFieldTypes"
                    :key="item.code"
                    :value="item.code"
                    :label="item.name"
                  ></vxe-option>
                </vxe-select>
              </template>
            </vxe-form-item>
            <vxe-form-item
              field="config.validators"
              title="字段验证"
              :span="24"
              :item-render="{}"
            >
              <template #default="{ data }">
                <vxe-select
                  ref="validator"
                  v-model="data.config.validators"
                  placeholder="请选择"
                  transfer
                  multiple
                >
                  <vxe-option
                    v-for="item in validators"
                    :key="item.code"
                    :value="item.code"
                    :label="item.name"
                  ></vxe-option>
                </vxe-select>
              </template>
            </vxe-form-item>
            <vxe-form-item
              field="config.format"
              title="格式化"
              :span="24"
              :item-render="{}"
              :visible="formData.type === 'number' || formData.type === 'date'"
            >
              <template #default="{ data }">
                <vxe-select
                  v-model="data.config.format"
                  placeholder="请选择"
                  transfer
                >
                  <vxe-option
                    v-for="item in formData.type === 'number'?formatNumber:formatDate"
                    :key="item.code"
                    :value="item.code"
                    :label="item.name"
                  ></vxe-option>
                </vxe-select>
              </template>
            </vxe-form-item>
            <vxe-form-item
              field="config.precision"
              title="精度"
              :span="24"
              :item-render="{}"
              :visible="formData.type === 'number'"
            >
              <template #default="{ data }">
                <vxe-input
                  v-model="data.config.precision"
                  :min="0"
                  type="integer"
                  placeholder="请输入精度"
                ></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item
              field="config.min"
              title="最小值"
              :span="24"
              :item-render="{}"
              :visible="formData.type === 'number'"
            >
              <template #default="{ data }">
                <vxe-input
                  v-model="data.config.min"
                  :min="minVal"
                  :max="maxVal"
                  type="integer"
                  placeholder="请输入最小值"
                ></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item
              field="config.max"
              title="最大值"
              :span="24"
              :item-render="{}"
              :visible="formData.type === 'number' || formData.type === 'input' || formData.type === 'textarea'"
            >
              <template #default="{ data }">
                <vxe-input
                  v-model="data.config.max"
                  :min="minVal"
                  :max="maxVal"
                  type="integer"
                  placeholder="请输入最大值"
                ></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item
              field="config.type"
              title="选项类型"
              :span="24"
              :item-render="{}"
              :visible="formData.type === 'switch' || formData.type === 'radio' || formData.type === 'select' || formData.type === 'multiSelect'"
              @change="typeChange(data)"
            >
              <template #default="{ data }">
                <vxe-select
                  v-model="data.config.type"
                  placeholder="请选择"
                  transfer
                  @change="selectTypeChange(data)"
                >
                  <vxe-option
                    v-for="item in selectType"
                    :key="item.code"
                    :value="item.code"
                    :label="item.name"
                  ></vxe-option>
                </vxe-select>
              </template>
            </vxe-form-item>
            <vxe-form-item
              field="config.key"
              title="动态选项"
              :span="24"
              :item-render="{}"
              :visible="formData.config.type === 'dict'"
            >
              <template #default="{ data }">
                <vxe-select
                  v-model="data.config.key"
                  placeholder="请选择"
                  transfer
                  filterable
                  clearable
                >
                  <vxe-option
                    v-for="item in dicData"
                    :key="item.typeKey"
                    :value="item.typeKey"
                    :label="item.text"
                  ></vxe-option>
                </vxe-select>
              </template>
            </vxe-form-item>
            <vxe-form-item
              field="config.option"
              title="自定义选项"
              :span="24"
              :item-render="{}"
              :visible="formData.config.type === 'custom'"
            >
              <template #default="{ data }">
                <table>
                  <tr class="linkageTable-tr">
                    <td style="width: 100px;">选项值</td>
                    <td>选项标签</td>
                    <td style="width: 100px;text-align: center">操作</td>
                  </tr>
                  <tr
                    v-for="(item, index) in data.config.option"
                    :key="index"
                  >
                    <td>
                      <el-input
                        size="mini"
                        v-model="item.value"
                        maxlength="20"
                        placeholder="选项值"
                      ></el-input>
                    </td>
                    <td>
                      <el-input
                        size="mini"
                        v-model="item.label"
                        maxlength="20"
                        placeholder="选项标签"
                      ></el-input>
                    </td>
                    <td style="text-align: center;">
                      <el-button
                        class="btn-padding"
                        size="mini"
                        icon="el-icon-plus"
                        @click="data.config.option.push({ key: '', value: '' })"
                      ></el-button>
                      <el-button
                        class="btn-padding"
                        size="mini"
                        style="margin-left:5px;"
                        icon="el-icon-delete"
                        v-if="data.config.option.length > 1"
                        @click="data.config.option.remove(item)"
                      ></el-button>
                    </td>
                  </tr>
                </table>
              </template>
            </vxe-form-item>
            <!--操作按钮-->
            <vxe-form-item
              align="center"
              title-align="left"
              :span="24"
            >
              <template #default>
                <vxe-button
                  type="submit"
                  status="primary"
                >保存</vxe-button>
                <vxe-button type="reset">重置</vxe-button>
              </template>
            </vxe-form-item>
          </vxe-form>
        </template>
      </vxe-modal>
    </el-drawer>
  </div>
</template>

<script>
import VXETable from 'vxe-table'
import * as constants from './constants'
import form from '@/api/form'
import { optionType } from './constants'

export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      drawerSize: '90%',
      submitLoading: false,
      pageBean: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      height: '100%',
      configId: null,
      formId: null,
      formKey: null,
      formName: null,
      formVersion: null,
      formStatus: null,
      schema: [],
      dicData: [],
      formData: {
        label: null,
        order: null,
        type: null,
        enabled: true,
        config: {
          validators: null,
          format: null,
          precision: null,
          min: null,
          max: null,
          type: null,
          key: null,
          option: null
        }
      },
      minVal: 0,
      maxVal: 200,
      formRules: {
        label: [
          { required: true, message: '名称必须填写' },
          { min: 0, max: 15, message: '长度在 0 到 15 个字符' }
        ],
        order: [{ required: true, message: '排序必须填写' }],
        type: [{ required: true, message: '字段类型必须填写' }]
      },
      selectRow: null,
      showEdit: false,
      tenantId: '',
      ...constants
    }
  },
  mounted() {
    this.tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
    this.height = this.tenantId && this.tenantId != -1 ? 'calc(100% - 56px)' : '100%'

    this.getAllDict()
  },
  methods: {
    async showDialog(param) {
      this.configId = null
      this.formId = param.formId
      this.formKey = param.formKey
      this.formName = param.formName
      this.formVersion = param.version
      this.formStatus = 'enable'
      this.dialogVisible = true

      await this.loadList(param.formKey)
    },
    async loadList(formKey) {
      this.loading = true
      try {
        await form.getFormExpandConfigByFormKey(formKey).then((resp) => {
          if (resp && resp.id) {
            this.configId = resp.id
            this.formStatus = resp.status
            this.schema = resp.schema
          } else {
            this.configId = null
            this.formStatus = 'enable'
            this.schema = []
          }
        })
      } catch (e) {
        console.error(e)
        this.schema = []
      } finally {
        this.loading = false
      }
    },
    async insertEvent() {
      this.showEdit = true
      this.selectRow = null
      Object.assign(this.formData, {
        id: null,
        label: null,
        order: null,
        type: null,
        enabled: true,
        config_id: this.configId,
        config: {
          validators: null,
          format: null,
          precision: null,
          min: null,
          max: null,
          type: null,
          key: null,
          option: null
        }
      })
    },
    editEvent(row) {
      this.selectRow = row
      this.showEdit = true
      Object.assign(this.formData, this.selectRow)
    },
    async removeEvent(row) {
      const type = await VXETable.modal.confirm('您确定要删除该数据?')
      const $table = this.$refs.xTable
      if (type === 'confirm') {
        $table.remove(row)
      }
    },
    submitEvent() {
      const $table = this.$refs.xTable
      this.$refs.configForm.validate((valid) => {
        if (!valid) {
          //表单验证
          this.showEdit = false
          if (this.selectRow) {
            Object.assign(this.selectRow, this.formData)
          } else {
            // VXETable.modal.message({ content: '新增成功', status: 'success' })
            $table.insertAt(this.formData, -1)
          }
        }
      })
    },
    typeChange(data) {
      if (data.type === 'input') {
        this.minVal = 0
        this.maxVal = 200
      } else if (data.type === 'textarea') {
        this.minVal = 0
        this.maxVal = 3000
      } else {
        this.minVal = -999999999
        this.maxVal = 999999999
      }
      // 验证规则
      this.changeRules()

      Object.assign(this.formData, {
        label: data.label,
        order: data.order,
        type: data.type,
        enabled: true,
        config: {
          validators: null,
          format: null,
          precision: null,
          min: null,
          max: null,
          type: null,
          key: null,
          option: null
        }
      })
    },
    selectTypeChange(data) {
      Object.assign(this.formData, {
        label: data.label,
        order: data.order,
        type: data.type,
        enabled: true,
        config: {
          validators: data.config.validators,
          format: null,
          precision: null,
          min: null,
          max: null,
          type: data.config.type,
          key: null,
          option: data.config.type === 'dict' ? null : [{ key: '', value: '' }]
        }
      })
    },
    changeRules() {
      this.formRules['config.format'] = []
      this.formRules['config.precision'] = []
      this.formRules['config.min'] = []
      this.formRules['config.max'] = []
      this.formRules['config.type'] = []
      this.formRules['config.key'] = []
      this.formRules['config.option'] = []

      if (this.formData.type === 'input' || this.formData.type === 'textarea') {
        this.formRules['config.max'] = [{ required: true, message: '最大值必须填写' }]
      } else if (this.formData.type === 'number') {
        this.formRules['config.format'] = [{ required: true, message: '格式化必须填写' }]
        this.formRules['config.precision'] = [{ required: true, message: '格式化必须填写' }]
        this.formRules['config.min'] = [{ required: true, message: '最小值必须填写' }]
        this.formRules['config.max'] = [{ required: true, message: '最大值必须填写' }]
      } else if (this.formData.type === 'date') {
        this.formRules['config.format'] = [{ required: true, message: '格式化必须填写' }]
      } else if (this.formData.type === 'radio' || this.formData.type === 'select' || this.formData.type === 'multiSelect') {
        this.formRules['config.type'] = [{ required: true, message: '选项类型必须填写' }]
        if (this.formData.config.type === 'dict') {
          this.formRules['config.key'] = [{ required: true, message: '动态选项必须填写' }]
        } else if (this.formData.config.type === 'custom') {
          this.formRules['config.option'] = [{ required: true, message: '自定义选项必须填写' }]
        }
      }
    },
    // 获取数据字典
    getAllDict() {
      form.getCategory('DIC', (data) => {
        this.dicData = data.data
      })
    },
    // 提交操作
    async saveEvent() {
      const $table = this.$refs.xTable
      const { insertRecords, removeRecords, updateRecords } = $table.getRecordset()
      // if (insertRecords.length <= 0 && removeRecords.length <= 0 && updateRecords.length <= 0) {
      //   VXETable.modal.message({ content: '数据未改动！', status: 'warning' })
      //   return
      // }
      const errMap = await $table.validate().catch((errMap) => errMap)
      if (errMap) {
        return
      }
      this.loading = true
      try {
        this.schema = $table.getTableData().tableData
        const body = {
          form_id: this.formId,
          form_key: this.formKey,
          version: this.formVersion,
          status: this.formStatus,
          schema: this.schema
        }
        if (this.configId) {
          body.id = this.configId
          body.insertRecords = insertRecords
          body.updateRecords = updateRecords
          body.removeRecords = removeRecords
          await form.updateFormExpandConfig(body).then((resp) => {
            this.loadList(this.formKey)
            VXETable.modal.message({ content: `操作成功`, status: 'success' })
          })
        } else {
          await form.saveFormExpandConfig(body).then((resp) => {
            this.loadList(this.formKey)
            VXETable.modal.message({ content: `操作成功`, status: 'success' })
          })
        }
      } catch (e) {
        if (e && e.message) {
          VXETable.modal.message({ content: e.message, status: 'error' })
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.surfBtn {
  cursor: pointer;
  color: '#007AFF';
}
</style>
